function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { decrementPrefetchCounter } from "../../internal/prefetching/decrementPrefetchCounter";
import { getOperationName } from "../../internal/shared/utils/gql";
import useDataConfig from "../useDataConfig";
/**
 * @see https://sail.stripe.me/data/api/useRefetchQueries
 */ export default function useRefetchQueries() {
    const client = useApolloClient();
    const dataConfig = useDataConfig();
    return useCallback(function() {
        var _ref = // We intentionally returns no results.
        _async_to_generator(function*(queries) {
            var _dataConfig_graphql_prefetch, _dataConfig_graphql;
            /*
        Only include prefetch counter logic when mismatch metrics are enabled
      */ if ((_dataConfig_graphql = dataConfig.graphql) === null || _dataConfig_graphql === void 0 ? void 0 : (_dataConfig_graphql_prefetch = _dataConfig_graphql.prefetch) === null || _dataConfig_graphql_prefetch === void 0 ? void 0 : _dataConfig_graphql_prefetch.enableMismatchMetrics) {
                yield client.refetchQueries({
                    include: queries,
                    onQueryUpdated: (observableQuery)=>{
                        const operationName = getOperationName(observableQuery.options.query);
                        /*
              The context object in here can be anything, but it's the closest we have to accurate values.
              Using the context given from useGetApolloContext without options yields incorrect values in the project field.
            */ decrementPrefetchCounter({
                            component: observableQuery.options.context.component,
                            service: observableQuery.options.context.service,
                            project: observableQuery.options.context.queryProject,
                            operationName: operationName || '',
                            variables: observableQuery.variables || {}
                        });
                        return observableQuery.refetch();
                    }
                });
            } else {
                yield client.refetchQueries({
                    include: queries
                });
            }
        });
        return function(queries) {
            return _ref.apply(this, arguments);
        };
    }(), [
        client,
        dataConfig
    ]);
}

//# sourceMappingURL=useRefetchQueries.js.map